import * as React from "react";
import { SVGProps } from "react";
const SvgChevronBoldUp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27.001 23.03a.998.998 0 0 1-.837-.45c-2.665-4.057-6.1-8.043-9.934-11.528a.36.36 0 0 0-.462 0c-3.833 3.485-7.268 7.47-9.932 11.527a1 1 0 1 1-1.672-1.098c2.756-4.195 6.303-8.313 10.259-11.91a2.364 2.364 0 0 1 3.151 0c3.958 3.596 7.506 7.714 10.262 11.91a1 1 0 0 1-.714 1.542l-.121.008v-.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronBoldUp;
